import { default as t } from './i18n';

function validateEmail(email) {
  let error = null;
  if (email === '') {
    error = 'Email required';
  } else if (email && email !== '' && !/\S+@\S+\.\S+/.test(email)) {
    error = t('error.validation.invalidPassword');
  }

  return error;
}

function validateConfirmPassword(password, confirmPassword) {
  let error = null;

  if (password && confirmPassword) {
    if (password !== confirmPassword) {
      error = t('error.validation.passwordDoNotMatch');
    }
  }
  return error;
}

export { validateEmail, validateConfirmPassword };
